import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=471c8667&scoped=true&"
import script from "./Page4.vue?vue&type=script&lang=js&"
export * from "./Page4.vue?vue&type=script&lang=js&"
import style0 from "./Page4.vue?vue&type=style&index=0&id=471c8667&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471c8667",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('471c8667')) {
      api.createRecord('471c8667', component.options)
    } else {
      api.reload('471c8667', component.options)
    }
    module.hot.accept("./Page4.vue?vue&type=template&id=471c8667&scoped=true&", function () {
      api.rerender('471c8667', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Page4.vue"
export default component.exports